import React from 'react';
import './App.css';

const projects = [
  {
    number: '01',
    title: 'Sistema Inteligente de Monitoramento Hidro Meteorológico',
    description:
      'Uma aplicação Back-end que consulta apis de geolocalização e previsão de tempo em tempo real, histórico pluviometrico, estações hidrologicas em tempo real e cruza essas informações para fornecer um índice de risco de enchentes para uma determinada região.',
    link: 'https://github.com/Wuhpeters/SIMHM',
  },
  {
    number: '02',
    title: 'Crescer lvl 1 - CWI',
    description:
      'Atividades práticas, jogos e exercícios com foco em lógica, colaboração e contato com front-end e back-end.',
    link: 'https://github.com/Wuhpeters?tab=repositories',
  },
];

function App() {
  return (
    <div className="container">
      <div className="left">
        <div className="left-inner">
          <div className="info">
            <img className="profile-image" src="/perfil.jpeg" alt="William Peters" />
            <h1 className="name">William Peters</h1>
            <p className="intro-name">Desenvolvedor Full Stack apaixonado por tecnologia e por transformar ideias em soluções únicas. Atuo na área financeira, desenvolvendo aplicações modernas, eficientes, escaláveis e seguras, sempre com foco na qualidade e na geração de valor para o cliente.</p>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/william-peters-bb42861b0/" title="LinkedIn" className="fa fa-linkedin" target="_blank" rel="noopener noreferrer"></a>
              <a href="https://github.com/Wuhpeters?tab=repositories" title="GitHub" className="fa fa-github" target="_blank" rel="noopener noreferrer"></a>
              <a href="mailto: william@williampeters.com.br" title="E-mail" className="fa fa-envelope"></a>
            </div>
          </div>
        </div>
      </div>

      <div className="right">
        <div className="right-inner">
          <section className="projects">
            <div className="content project-grid">
              {projects.map((project, index) => (
                <article
                  key={project.number}
                  className={`project-item ${index % 2 === 1 ? 'is-reversed' : ''}`}
                >
                  <a
                    href={project.link}
                    className="project-media"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${project.title}`}
                  >
                  </a>
                  <div className="project-copy">
                    <h5 className="project-title">{project.title}</h5>
                    <p className="project-desc">{project.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </section>

          <footer className="page-footer" aria-label="Rodapé do portfólio">
            <a href="mailto:william@williampeters.com.br" className="page-footer-email">
              william@williampeters.com.br
            </a>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default App;
